function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "442px",
    height: "205px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 1.5,-0.5 C 1.83333,-0.5 2.16667,-0.5 2.5,-0.5C 2.61071,0.117425 2.94404,0.617425 3.5,1C 148.167,1.66667 292.833,1.66667 437.5,1C 438.056,0.617425 438.389,0.117425 438.5,-0.5C 438.833,-0.5 439.167,-0.5 439.5,-0.5C 439.5,67.8333 439.5,136.167 439.5,204.5C 439.167,204.5 438.833,204.5 438.5,204.5C 438.389,203.883 438.056,203.383 437.5,203C 292.833,202.333 148.167,202.333 3.5,203C 2.94404,203.383 2.61071,203.883 2.5,204.5C 2.16667,204.5 1.83333,204.5 1.5,204.5C 1.5,136.167 1.5,67.8333 1.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f5f5",
    d: "M 2.5,-0.5 C 147.833,-0.5 293.167,-0.5 438.5,-0.5C 438.389,0.117425 438.056,0.617425 437.5,1C 292.833,1.66667 148.167,1.66667 3.5,1C 2.94404,0.617425 2.61071,0.117425 2.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M -0.5,-0.5 C 0.166667,-0.5 0.833333,-0.5 1.5,-0.5C 1.5,67.8333 1.5,136.167 1.5,204.5C 0.833333,204.5 0.166667,204.5 -0.5,204.5C -0.5,136.167 -0.5,67.8333 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M 439.5,-0.5 C 440.167,-0.5 440.833,-0.5 441.5,-0.5C 441.5,67.8333 441.5,136.167 441.5,204.5C 440.833,204.5 440.167,204.5 439.5,204.5C 439.5,136.167 439.5,67.8333 439.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5ccdc",
    d: "M 126.5,29.5 C 126.167,29.5 125.833,29.5 125.5,29.5C 95.1667,29.5 64.8333,29.5 34.5,29.5C 33.5489,30.9187 33.2155,32.5853 33.5,34.5C 32.1888,32.4402 32.1888,30.2735 33.5,28C 49,27.8333 64.5,27.6667 80,27.5C 95.848,27.5006 111.348,28.1672 126.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1c8d9",
    d: "M 232.5,29.5 C 199.833,29.5 167.167,29.5 134.5,29.5C 134.5,30.8333 134.5,32.1667 134.5,33.5C 142.316,34.4924 150.316,34.8257 158.5,34.5C 158.5,60.8333 158.5,87.1667 158.5,113.5C 158.167,113.5 157.833,113.5 157.5,113.5C 157.5,87.5 157.5,61.5 157.5,35.5C 149.5,35.5 141.5,35.5 133.5,35.5C 133.5,32.8333 133.5,30.1667 133.5,27.5C 166.168,27.3334 198.835,27.5 231.5,28C 232.056,28.3826 232.389,28.8826 232.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dee2ea",
    d: "M 320.5,28.5 C 333.496,27.8334 346.662,27.5001 360,27.5C 373.517,27.5008 386.684,28.1675 399.5,29.5C 399.167,29.5 398.833,29.5 398.5,29.5C 372.672,28.5022 346.672,28.1689 320.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92a1bc",
    d: "M 320.5,28.5 C 346.672,28.1689 372.672,28.5022 398.5,29.5C 372.833,29.5 347.167,29.5 321.5,29.5C 318.402,29.7556 315.402,30.4222 312.5,31.5C 314.617,29.3455 317.284,28.3455 320.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#455d8d",
    d: "M 34.5,29.5 C 64.8333,29.5 95.1667,29.5 125.5,29.5C 125.5,30.8333 125.5,32.1667 125.5,33.5C 117.5,33.5 109.5,33.5 101.5,33.5C 94.6992,32.1694 87.5325,31.5028 80,31.5C 72.2654,31.5344 64.7654,32.201 57.5,33.5C 49.8333,33.5 42.1667,33.5 34.5,33.5C 34.5,32.1667 34.5,30.8333 34.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a6190",
    d: "M 232.5,29.5 C 239.407,30.4526 244.74,33.7859 248.5,39.5C 249.508,41.5439 250.508,43.5439 251.5,45.5C 254.825,53.8656 253.492,61.5323 247.5,68.5C 246.596,69.209 246.263,70.209 246.5,71.5C 251.167,71.5 255.833,71.5 260.5,71.5C 263.901,72.6344 267.234,73.9677 270.5,75.5C 272.167,77.5 273.833,79.5 275.5,81.5C 278.554,88.2312 277.72,88.8978 273,83.5C 272.536,84.0944 272.369,84.7611 272.5,85.5C 272.167,85.5 271.833,85.5 271.5,85.5C 271.262,83.5956 270.262,82.2623 268.5,81.5C 266.999,80.2485 265.332,79.2485 263.5,78.5C 262.22,77.0687 260.553,76.4021 258.5,76.5C 248.681,75.506 238.681,75.1726 228.5,75.5C 228.5,74.5 228.5,73.5 228.5,72.5C 230.099,72.7678 231.432,72.4345 232.5,71.5C 232.833,71.5 233.167,71.5 233.5,71.5C 235.967,71.2451 237.967,70.2451 239.5,68.5C 244.523,66.1356 247.19,62.1356 247.5,56.5C 247.813,52.9581 247.479,49.6248 246.5,46.5C 246.573,44.9731 245.906,43.9731 244.5,43.5C 242.973,41.0615 240.973,39.0615 238.5,37.5C 238.027,36.0937 237.027,35.427 235.5,35.5C 234.833,35.5 234.167,35.5 233.5,35.5C 233.5,34.8333 233.167,34.5 232.5,34.5C 215.173,33.2542 197.673,32.2542 180,31.5C 172.467,31.5028 165.301,32.1694 158.5,33.5C 150.5,33.5 142.5,33.5 134.5,33.5C 134.5,32.1667 134.5,30.8333 134.5,29.5C 167.167,29.5 199.833,29.5 232.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#445d8d",
    d: "M 321.5,29.5 C 347.167,29.5 372.833,29.5 398.5,29.5C 398.5,30.8333 398.5,32.1667 398.5,33.5C 378.993,33.1697 359.659,33.503 340.5,34.5C 338.883,35.038 337.216,35.3713 335.5,35.5C 334.624,35.6309 333.957,35.2975 333.5,34.5C 335.274,33.8133 336.941,32.9799 338.5,32C 332.167,31.6667 325.833,31.3333 319.5,31C 320.416,30.7216 321.082,30.2216 321.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#556a96",
    d: "M 101.5,33.5 C 101.5,33.8333 101.5,34.1667 101.5,34.5C 101.169,61.3386 101.502,88.0052 102.5,114.5C 102.389,115.117 102.056,115.617 101.5,116C 87.1667,116.667 72.8333,116.667 58.5,116C 57.944,115.617 57.6107,115.117 57.5,114.5C 58.8333,87.8333 58.8333,61.1667 57.5,34.5C 57.5,34.1667 57.5,33.8333 57.5,33.5C 64.7654,32.201 72.2654,31.5344 80,31.5C 87.5325,31.5028 94.6992,32.1694 101.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#566b96",
    d: "M 232.5,34.5 C 222.167,34.5 211.833,34.5 201.5,34.5C 201.5,60.8333 201.5,87.1667 201.5,113.5C 220.5,113.5 239.5,113.5 258.5,113.5C 240.004,114.332 221.338,114.832 202.5,115C 201.944,115.383 201.611,115.883 201.5,116.5C 186.462,117.15 171.795,116.483 157.5,114.5C 158.167,114.5 158.5,114.167 158.5,113.5C 159.833,86.8333 159.833,60.1667 158.5,33.5C 165.301,32.1694 172.467,31.5028 180,31.5C 197.673,32.2542 215.173,33.2542 232.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#556b96",
    d: "M 321.5,29.5 C 321.082,30.2216 320.416,30.7216 319.5,31C 325.833,31.3333 332.167,31.6667 338.5,32C 336.941,32.9799 335.274,33.8133 333.5,34.5C 333.957,35.2975 334.624,35.6309 335.5,35.5C 334.833,36.1667 334.167,36.8333 333.5,37.5C 325.147,39.8437 318.814,44.8437 314.5,52.5C 313.094,52.9731 312.427,53.9731 312.5,55.5C 311.094,55.9731 310.427,56.9731 310.5,58.5C 310.443,59.609 310.11,60.609 309.5,61.5C 307.952,65.034 307.286,68.8673 307.5,73C 307.502,76.0208 307.836,78.8541 308.5,81.5C 309.492,84.8229 310.492,88.1563 311.5,91.5C 311.427,93.0269 312.094,94.0269 313.5,94.5C 316.457,98.7921 319.79,102.792 323.5,106.5C 321.158,106.775 321.158,107.608 323.5,109C 327.596,111.715 331.93,113.882 336.5,115.5C 327.504,117.052 318.671,116.386 310,113.5C 309.5,113.667 309,113.833 308.5,114C 309.416,114.278 310.082,114.778 310.5,115.5C 309.833,115.5 309.167,115.5 308.5,115.5C 306.326,115.25 304.659,114.25 303.5,112.5C 303.027,111.094 302.027,110.427 300.5,110.5C 296.806,107.473 293.473,104.14 290.5,100.5C 290.573,98.9731 289.906,97.9731 288.5,97.5C 287.917,94.0534 286.584,91.0534 284.5,88.5C 283.002,78.4696 283.168,68.4696 285,58.5C 288.37,48.6256 294.536,40.9589 303.5,35.5C 305.027,35.573 306.027,34.9063 306.5,33.5C 308.421,32.6373 310.421,31.9707 312.5,31.5C 315.402,30.4222 318.402,29.7556 321.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8faf",
    d: "M 34.5,29.5 C 34.5,30.8333 34.5,32.1667 34.5,33.5C 42.1667,33.5 49.8333,33.5 57.5,33.5C 57.5,33.8333 57.5,34.1667 57.5,34.5C 49.5,34.5 41.5,34.5 33.5,34.5C 33.2155,32.5853 33.5489,30.9187 34.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8fb0",
    d: "M 125.5,29.5 C 125.833,29.5 126.167,29.5 126.5,29.5C 126.784,31.4147 126.451,33.0813 125.5,34.5C 117.5,34.5 109.5,34.5 101.5,34.5C 101.5,34.1667 101.5,33.8333 101.5,33.5C 109.5,33.5 117.5,33.5 125.5,33.5C 125.5,32.1667 125.5,30.8333 125.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b8dae",
    d: "M 398.5,29.5 C 398.833,29.5 399.167,29.5 399.5,29.5C 399.5,31.1667 399.5,32.8333 399.5,34.5C 379.833,34.5 360.167,34.5 340.5,34.5C 359.659,33.503 378.993,33.1697 398.5,33.5C 398.5,32.1667 398.5,30.8333 398.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a6c0",
    d: "M 306.5,33.5 C 306.027,34.9063 305.027,35.573 303.5,35.5C 303.973,34.0937 304.973,33.427 306.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbd2df",
    d: "M 340.5,34.5 C 360.167,34.5 379.833,34.5 399.5,34.5C 379.671,35.3318 359.671,35.8318 339.5,36C 337.655,37.128 335.655,37.628 333.5,37.5C 334.167,36.8333 334.833,36.1667 335.5,35.5C 337.216,35.3713 338.883,35.038 340.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb8cc",
    d: "M 101.5,34.5 C 109.5,34.5 117.5,34.5 125.5,34.5C 118.018,35.492 110.352,35.8254 102.5,35.5C 102.5,61.5 102.5,87.5 102.5,113.5C 110.352,113.175 118.018,113.508 125.5,114.5C 117.833,114.5 110.167,114.5 102.5,114.5C 101.502,88.0052 101.169,61.3386 101.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#687ba2",
    d: "M 134.5,33.5 C 142.5,33.5 150.5,33.5 158.5,33.5C 159.833,60.1667 159.833,86.8333 158.5,113.5C 158.5,87.1667 158.5,60.8333 158.5,34.5C 150.316,34.8257 142.316,34.4924 134.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 233.5,35.5 C 234.167,35.5 234.833,35.5 235.5,35.5C 235.973,36.9063 236.973,37.573 238.5,37.5C 240.973,39.0615 242.973,41.0615 244.5,43.5C 244.427,45.0269 245.094,46.0269 246.5,46.5C 247.479,49.6248 247.813,52.9581 247.5,56.5C 245.75,61.0233 243.084,65.0233 239.5,68.5C 237.033,68.7549 235.033,69.7549 233.5,71.5C 233.167,71.5 232.833,71.5 232.5,71.5C 230.833,71.5 229.167,71.5 227.5,71.5C 227.5,73.1667 227.5,74.8333 227.5,76.5C 239.346,77.2727 251.346,77.9393 263.5,78.5C 265.332,79.2485 266.999,80.2485 268.5,81.5C 268.738,83.4044 269.738,84.7377 271.5,85.5C 271.427,87.0269 272.094,88.0269 273.5,88.5C 273.5,89.8333 273.5,91.1667 273.5,92.5C 273.492,95.5448 273.159,98.5448 272.5,101.5C 271.277,105.049 269.277,108.049 266.5,110.5C 265.391,110.557 264.391,110.89 263.5,111.5C 243.534,112.464 223.534,112.798 203.5,112.5C 203.5,86.8333 203.5,61.1667 203.5,35.5C 213.5,35.5 223.5,35.5 233.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b2c8",
    d: "M 235.5,35.5 C 237.027,35.427 238.027,36.0937 238.5,37.5C 236.973,37.573 235.973,36.9063 235.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e9ef",
    d: "M 33.5,34.5 C 41.5,34.5 49.5,34.5 57.5,34.5C 57.5,60.1667 57.5,85.8333 57.5,111.5C 56.5023,86.3388 56.1689,61.0055 56.5,35.5C 48.6484,35.8254 40.9818,35.492 33.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0d6e1",
    d: "M 232.5,34.5 C 233.167,34.5 233.5,34.8333 233.5,35.5C 223.5,35.5 213.5,35.5 203.5,35.5C 203.5,61.1667 203.5,86.8333 203.5,112.5C 223.534,112.798 243.534,112.464 263.5,111.5C 263.5,111.833 263.5,112.167 263.5,112.5C 261.883,113.038 260.216,113.371 258.5,113.5C 239.5,113.5 220.5,113.5 201.5,113.5C 201.5,87.1667 201.5,60.8333 201.5,34.5C 211.833,34.5 222.167,34.5 232.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8493b3",
    d: "M 248.5,39.5 C 250.975,40.6874 251.975,42.6874 251.5,45.5C 250.508,43.5439 249.508,41.5439 248.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9facc5",
    d: "M 244.5,43.5 C 245.906,43.9731 246.573,44.9731 246.5,46.5C 245.094,46.0269 244.427,45.0269 244.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2bccf",
    d: "M 365.5,50.5 C 367.698,50.1201 369.365,50.7868 370.5,52.5C 368.597,52.2041 366.93,51.5375 365.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4b0c7",
    d: "M 365.5,50.5 C 359.677,50.123 354.011,50.7897 348.5,52.5C 349.347,51.0337 350.68,50.2004 352.5,50C 357.02,49.1864 361.354,49.353 365.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#556a96",
    d: "M 365.5,50.5 C 366.93,51.5375 368.597,52.2041 370.5,52.5C 375.865,55.533 379.865,59.8663 382.5,65.5C 383.162,69.4659 383.495,73.4659 383.5,77.5C 382.019,85.1139 378.019,91.1139 371.5,95.5C 368.843,95.9348 366.509,96.9348 364.5,98.5C 363.833,98.5 363.167,98.5 362.5,98.5C 358.342,98.6684 354.342,98.0017 350.5,96.5C 342.926,93.2563 338.259,87.5896 336.5,79.5C 335.382,71.7178 337.049,64.7178 341.5,58.5C 343.239,55.7573 345.573,53.7573 348.5,52.5C 354.011,50.7897 359.677,50.123 365.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bac3d4",
    d: "M 314.5,52.5 C 314.573,54.0269 313.906,55.0269 312.5,55.5C 312.427,53.9731 313.094,52.9731 314.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba8c1",
    d: "M 312.5,55.5 C 312.573,57.0269 311.906,58.0269 310.5,58.5C 310.427,56.9731 311.094,55.9731 312.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#798aad",
    d: "M 341.5,58.5 C 337.049,64.7178 335.382,71.7178 336.5,79.5C 335.352,75.0189 335.185,70.3522 336,65.5C 336.935,62.4048 338.769,60.0714 341.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7788ab",
    d: "M 247.5,56.5 C 247.19,62.1356 244.523,66.1356 239.5,68.5C 243.084,65.0233 245.75,61.0233 247.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a2bd",
    d: "M 239.5,68.5 C 237.967,70.2451 235.967,71.2451 233.5,71.5C 235.033,69.7549 237.033,68.7549 239.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ca9c2",
    d: "M 247.5,68.5 C 251.373,70.4302 255.706,71.0969 260.5,70.5C 260.5,70.8333 260.5,71.1667 260.5,71.5C 255.833,71.5 251.167,71.5 246.5,71.5C 246.263,70.209 246.596,69.209 247.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccd3e1",
    d: "M 260.5,71.5 C 260.5,71.1667 260.5,70.8333 260.5,70.5C 261.873,70.3433 263.207,70.51 264.5,71C 267.014,71.8809 269.014,73.3809 270.5,75.5C 267.234,73.9677 263.901,72.6344 260.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b1c8",
    d: "M 382.5,65.5 C 383.926,67.6789 384.592,70.1789 384.5,73C 384.492,74.7067 384.158,76.2067 383.5,77.5C 383.495,73.4659 383.162,69.4659 382.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afbace",
    d: "M 309.5,61.5 C 308.669,68.1311 308.336,74.7978 308.5,81.5C 307.836,78.8541 307.502,76.0208 307.5,73C 307.286,68.8673 307.952,65.034 309.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f82a7",
    d: "M 232.5,71.5 C 231.432,72.4345 230.099,72.7678 228.5,72.5C 228.5,73.5 228.5,74.5 228.5,75.5C 238.681,75.1726 248.681,75.506 258.5,76.5C 248.167,76.5 237.833,76.5 227.5,76.5C 227.5,74.8333 227.5,73.1667 227.5,71.5C 229.167,71.5 230.833,71.5 232.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6cddc",
    d: "M 227.5,76.5 C 237.833,76.5 248.167,76.5 258.5,76.5C 260.553,76.4021 262.22,77.0687 263.5,78.5C 251.346,77.9393 239.346,77.2727 227.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bac2d5",
    d: "M 268.5,81.5 C 270.262,82.2623 271.262,83.5956 271.5,85.5C 269.738,84.7377 268.738,83.4044 268.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6779a1",
    d: "M 275.5,81.5 C 278.27,83.3658 279.77,86.0324 280,89.5C 280.694,93.554 280.527,97.554 279.5,101.5C 279.167,101.5 278.833,101.5 278.5,101.5C 278.666,97.1539 278.499,92.8206 278,88.5C 277.431,92.3605 276.598,92.3605 275.5,88.5C 275.167,89 274.833,89.5 274.5,90C 275.716,92.6526 275.716,95.1526 274.5,97.5C 274.784,95.5853 274.451,93.9187 273.5,92.5C 273.5,91.1667 273.5,89.8333 273.5,88.5C 273.443,87.391 273.11,86.391 272.5,85.5C 272.369,84.7611 272.536,84.0944 273,83.5C 277.72,88.8978 278.554,88.2312 275.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0abc5",
    d: "M 271.5,85.5 C 271.833,85.5 272.167,85.5 272.5,85.5C 273.11,86.391 273.443,87.391 273.5,88.5C 272.094,88.0269 271.427,87.0269 271.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3cbda",
    d: "M 284.5,88.5 C 286.584,91.0534 287.917,94.0534 288.5,97.5C 287.069,96.0975 285.902,94.4308 285,92.5C 284.51,91.2068 284.343,89.8734 284.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0abc5",
    d: "M 311.5,91.5 C 312.906,91.9731 313.573,92.9731 313.5,94.5C 312.094,94.0269 311.427,93.0269 311.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cad1de",
    d: "M 273.5,92.5 C 274.451,93.9187 274.784,95.5853 274.5,97.5C 274.34,99.153 273.674,100.486 272.5,101.5C 273.159,98.5448 273.492,95.5448 273.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bed0",
    d: "M 371.5,95.5 C 369.68,97.4484 367.346,98.4484 364.5,98.5C 366.509,96.9348 368.843,95.9348 371.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8cfdd",
    d: "M 350.5,96.5 C 354.342,98.0017 358.342,98.6684 362.5,98.5C 360.034,99.6341 357.367,99.8007 354.5,99C 352.68,98.7996 351.347,97.9663 350.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb6cb",
    d: "M 288.5,97.5 C 289.906,97.9731 290.573,98.9731 290.5,100.5C 289.094,100.027 288.427,99.0269 288.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3bdd0",
    d: "M 278.5,101.5 C 278.833,101.5 279.167,101.5 279.5,101.5C 279.843,103.483 279.176,104.817 277.5,105.5C 277.833,104.167 278.167,102.833 278.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2bdd1",
    d: "M 326.5,107.5 C 328.027,107.427 329.027,108.094 329.5,109.5C 327.973,109.573 326.973,108.906 326.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8393b2",
    d: "M 266.5,110.5 C 266.027,111.906 265.027,112.573 263.5,112.5C 263.5,112.167 263.5,111.833 263.5,111.5C 264.391,110.89 265.391,110.557 266.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c8dac",
    d: "M 300.5,110.5 C 302.027,110.427 303.027,111.094 303.5,112.5C 301.973,112.573 300.973,111.906 300.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3bdd1",
    d: "M 329.5,109.5 C 333.533,110.025 337.2,111.358 340.5,113.5C 336.327,113.333 332.66,112 329.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49618f",
    d: "M 278.5,101.5 C 278.167,102.833 277.833,104.167 277.5,105.5C 274.17,112.181 268.836,116.515 261.5,118.5C 220.167,118.5 178.833,118.5 137.5,118.5C 178.998,117.667 220.665,117.167 262.5,117C 242.169,116.5 221.836,116.333 201.5,116.5C 201.611,115.883 201.944,115.383 202.5,115C 221.338,114.832 240.004,114.332 258.5,113.5C 260.216,113.371 261.883,113.038 263.5,112.5C 265.027,112.573 266.027,111.906 266.5,110.5C 269.277,108.049 271.277,105.049 272.5,101.5C 273.674,100.486 274.34,99.153 274.5,97.5C 275.716,95.1526 275.716,92.6526 274.5,90C 274.833,89.5 275.167,89 275.5,88.5C 276.598,92.3605 277.431,92.3605 278,88.5C 278.499,92.8206 278.666,97.1539 278.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#455e8d",
    d: "M 323.5,106.5 C 324.391,107.11 325.391,107.443 326.5,107.5C 326.973,108.906 327.973,109.573 329.5,109.5C 332.66,112 336.327,113.333 340.5,113.5C 341.167,113.5 341.833,113.5 342.5,113.5C 360.993,114.497 379.659,114.83 398.5,114.5C 398.5,115.833 398.5,117.167 398.5,118.5C 371.5,118.5 344.5,118.5 317.5,118.5C 317.167,118.5 316.833,118.5 316.5,118.5C 314.5,117.5 312.5,116.5 310.5,115.5C 310.082,114.778 309.416,114.278 308.5,114C 309,113.833 309.5,113.667 310,113.5C 318.671,116.386 327.504,117.052 336.5,115.5C 331.93,113.882 327.596,111.715 323.5,109C 321.158,107.608 321.158,106.775 323.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e5889",
    d: "M 157.5,114.5 C 171.795,116.483 186.462,117.15 201.5,116.5C 221.836,116.333 242.169,116.5 262.5,117C 220.665,117.167 178.998,117.667 137.5,118.5C 136.5,118.5 135.5,118.5 134.5,118.5C 134.5,117.167 134.5,115.833 134.5,114.5C 142.167,114.5 149.833,114.5 157.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bbcf",
    d: "M 308.5,115.5 C 309.167,115.5 309.833,115.5 310.5,115.5C 312.5,116.5 314.5,117.5 316.5,118.5C 313.284,118.655 310.617,117.655 308.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a99b7",
    d: "M 57.5,34.5 C 58.8333,61.1667 58.8333,87.8333 57.5,114.5C 49.8333,114.5 42.1667,114.5 34.5,114.5C 34.5,115.833 34.5,117.167 34.5,118.5C 64.8333,118.5 95.1667,118.5 125.5,118.5C 125.5,117.167 125.5,115.833 125.5,114.5C 126.451,115.919 126.784,117.585 126.5,119.5C 95.5,119.5 64.5,119.5 33.5,119.5C 33.5,117.5 33.5,115.5 33.5,113.5C 41.9032,114.134 49.9032,113.467 57.5,111.5C 57.5,85.8333 57.5,60.1667 57.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#425b8a",
    d: "M 57.5,114.5 C 57.6107,115.117 57.944,115.617 58.5,116C 72.8333,116.667 87.1667,116.667 101.5,116C 102.056,115.617 102.389,115.117 102.5,114.5C 110.167,114.5 117.833,114.5 125.5,114.5C 125.5,115.833 125.5,117.167 125.5,118.5C 95.1667,118.5 64.8333,118.5 34.5,118.5C 34.5,117.167 34.5,115.833 34.5,114.5C 42.1667,114.5 49.8333,114.5 57.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d8eaf",
    d: "M 157.5,113.5 C 157.833,113.5 158.167,113.5 158.5,113.5C 158.5,114.167 158.167,114.5 157.5,114.5C 149.833,114.5 142.167,114.5 134.5,114.5C 134.5,115.833 134.5,117.167 134.5,118.5C 135.5,118.5 136.5,118.5 137.5,118.5C 178.833,118.5 220.167,118.5 261.5,118.5C 219.003,119.499 176.337,119.832 133.5,119.5C 133.5,117.5 133.5,115.5 133.5,113.5C 141.5,113.5 149.5,113.5 157.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8292b2",
    d: "M 342.5,113.5 C 361.5,113.5 380.5,113.5 399.5,113.5C 399.5,115.5 399.5,117.5 399.5,119.5C 371.995,119.831 344.662,119.498 317.5,118.5C 344.5,118.5 371.5,118.5 398.5,118.5C 398.5,117.167 398.5,115.833 398.5,114.5C 379.659,114.83 360.993,114.497 342.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f90b1",
    d: "M 66.5,132.5 C 64.1432,132.337 61.8098,132.503 59.5,133C 57.9632,134.11 57.2965,135.61 57.5,137.5C 56.1134,135.511 56.4468,133.678 58.5,132C 61.367,131.199 64.0336,131.366 66.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92a0bc",
    d: "M 82.5,132.5 C 78.8183,132.335 75.1516,132.501 71.5,133C 73.0581,133.21 74.3915,133.71 75.5,134.5C 75.5,138.5 75.5,142.5 75.5,146.5C 74.5166,142.702 74.1832,138.702 74.5,134.5C 73.1667,134.5 71.8333,134.5 70.5,134.5C 70.5,133.5 70.5,132.5 70.5,131.5C 74.7016,131.183 78.7016,131.517 82.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8696b5",
    d: "M 102.5,132.5 C 98.8183,132.335 95.1516,132.501 91.5,133C 93.0581,133.21 94.3915,133.71 95.5,134.5C 93.8333,134.5 92.1667,134.5 90.5,134.5C 90.5,133.5 90.5,132.5 90.5,131.5C 94.7016,131.183 98.7016,131.517 102.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c8daf",
    d: "M 129.5,134.5 C 130.263,133.732 131.263,133.232 132.5,133C 129.167,132.333 125.833,132.333 122.5,133C 123.737,133.232 124.737,133.732 125.5,134.5C 124.167,134.5 122.833,134.5 121.5,134.5C 121.5,133.5 121.5,132.5 121.5,131.5C 125.5,131.5 129.5,131.5 133.5,131.5C 133.5,132.5 133.5,133.5 133.5,134.5C 132.167,134.5 130.833,134.5 129.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7386a8",
    d: "M 336.5,132.5 C 334.265,132.205 332.265,132.539 330.5,133.5C 329.833,133.5 329.167,133.5 328.5,133.5C 329.492,131.974 330.992,131.307 333,131.5C 334.385,131.514 335.551,131.848 336.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b99b7",
    d: "M 348.5,146.5 C 348.5,142.167 348.5,137.833 348.5,133.5C 350.978,132.306 348.978,132.139 342.5,133C 343.737,133.232 344.737,133.732 345.5,134.5C 344.167,134.5 342.833,134.5 341.5,134.5C 341.5,133.5 341.5,132.5 341.5,131.5C 345.5,131.5 349.5,131.5 353.5,131.5C 353.5,132.5 353.5,133.5 353.5,134.5C 352.167,134.5 350.833,134.5 349.5,134.5C 349.817,138.702 349.483,142.702 348.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#415889",
    d: "M 82.5,132.5 C 81.8166,134.176 80.4832,134.843 78.5,134.5C 77.6773,137.977 77.1773,141.644 77,145.5C 76.8227,141.644 76.3227,137.977 75.5,134.5C 74.3915,133.71 73.0581,133.21 71.5,133C 75.1516,132.501 78.8183,132.335 82.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#405889",
    d: "M 102.5,132.5 C 101.817,134.176 100.483,134.843 98.5,134.5C 97.6773,137.977 97.1773,141.644 97,145.5C 96.8227,141.644 96.3227,137.977 95.5,134.5C 94.3915,133.71 93.0581,133.21 91.5,133C 95.1516,132.501 98.8183,132.335 102.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8595b4",
    d: "M 288.5,132.5 C 281.477,131.53 277.81,134.53 277.5,141.5C 275.69,137.623 276.69,134.457 280.5,132C 283.367,131.199 286.034,131.366 288.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#596d98",
    d: "M 336.5,132.5 C 337.376,132.369 338.043,132.702 338.5,133.5C 335.914,134.48 333.247,134.813 330.5,134.5C 330.5,134.167 330.5,133.833 330.5,133.5C 332.265,132.539 334.265,132.205 336.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#556b97",
    d: "M 394.5,134.5 C 393.677,137.977 393.177,141.644 393,145.5C 392.823,141.644 392.323,137.977 391.5,134.5C 390.167,134.5 388.833,134.5 387.5,134.5C 387.5,133.5 387.5,132.5 387.5,131.5C 391.167,131.5 394.833,131.5 398.5,131.5C 398.5,132.5 398.5,133.5 398.5,134.5C 397.167,134.5 395.833,134.5 394.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b8daf",
    d: "M 183.5,132.5 C 184.043,132.56 184.376,132.893 184.5,133.5C 181.914,134.48 179.247,134.813 176.5,134.5C 178.833,133.833 181.167,133.167 183.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61749d",
    d: "M 302.5,132.5 C 300.801,132.34 299.134,132.506 297.5,133C 299.382,133.198 301.048,133.698 302.5,134.5C 300.379,134.325 298.379,134.659 296.5,135.5C 296.158,134.662 295.492,134.328 294.5,134.5C 296.615,131.483 299.282,130.816 302.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d6391",
    d: "M 66.5,132.5 C 66.8333,132.5 67.1667,132.5 67.5,132.5C 67.5,133.833 66.8333,134.5 65.5,134.5C 63.8333,134.5 62.1667,134.5 60.5,134.5C 59.1148,135.947 59.4482,136.947 61.5,137.5C 64.0878,137.543 66.2544,138.543 68,140.5C 68.7603,145.074 66.7603,147.074 62,146.5C 60.2933,146.492 58.7933,146.158 57.5,145.5C 59.9479,144.527 62.6146,144.194 65.5,144.5C 65.8432,142.517 65.1765,141.183 63.5,140.5C 60.6874,140.975 58.6874,139.975 57.5,137.5C 57.2965,135.61 57.9632,134.11 59.5,133C 61.8098,132.503 64.1432,132.337 66.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb8ce",
    d: "M 67.5,132.5 C 68.404,133.209 68.7373,134.209 68.5,135.5C 67.209,135.737 66.209,135.404 65.5,134.5C 66.8333,134.5 67.5,133.833 67.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5cddb",
    d: "M 109.5,142.5 C 108.521,139.375 108.187,136.042 108.5,132.5C 107.5,132.5 106.5,132.5 105.5,132.5C 106.077,130.348 107.244,130.015 109,131.5C 109.499,135.152 109.665,138.818 109.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8ebf1",
    d: "M 145.5,134.5 C 148.254,136.053 149.087,138.386 148,141.5C 144.706,145.473 141.54,145.473 138.5,141.5C 137.833,136.167 140.167,133.833 145.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfc8d8",
    d: "M 198.5,132.5 C 199.209,131.596 200.209,131.263 201.5,131.5C 201.5,135.5 201.5,139.5 201.5,143.5C 203.833,143.5 206.167,143.5 208.5,143.5C 206.469,143.972 204.802,144.972 203.5,146.5C 202.5,146.5 201.5,146.5 200.5,146.5C 201.103,141.381 200.436,136.715 198.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#475f8e",
    d: "M 211.5,143.5 C 209.609,146.172 206.942,147.172 203.5,146.5C 204.802,144.972 206.469,143.972 208.5,143.5C 209.166,139.979 209.833,136.313 210.5,132.5C 211.489,136.107 211.823,139.774 211.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7284a9",
    d: "M 224.5,134.5 C 223.833,134.167 223.167,133.833 222.5,133.5C 221.923,132.227 221.257,132.227 220.5,133.5C 220.957,134.298 221.624,134.631 222.5,134.5C 222.5,135.167 222.5,135.833 222.5,136.5C 221.5,136.5 220.5,136.5 219.5,136.5C 219.062,135.494 218.396,135.494 217.5,136.5C 217.691,132.467 219.691,130.967 223.5,132C 224.252,132.671 224.586,133.504 224.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#173470",
    d: "M 222.5,133.5 C 222.5,133.833 222.5,134.167 222.5,134.5C 221.624,134.631 220.957,134.298 220.5,133.5C 221.257,132.227 221.923,132.227 222.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d8daf",
    d: "M 243.5,132.5 C 243.573,134.027 242.906,135.027 241.5,135.5C 241.427,133.973 242.094,132.973 243.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb6cb",
    d: "M 289.5,132.5 C 290.404,133.209 290.737,134.209 290.5,135.5C 289.209,135.737 288.209,135.404 287.5,134.5C 288.833,134.5 289.5,133.833 289.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3d9e3",
    d: "M 313.5,132.5 C 312.833,132.5 312.167,132.5 311.5,132.5C 310.514,136.97 310.181,141.637 310.5,146.5C 309.35,141.684 309.184,136.684 310,131.5C 311.756,130.015 312.923,130.348 313.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccd3e0",
    d: "M 321.5,131.5 C 322.055,135.012 321.388,138.012 319.5,140.5C 319.167,139.833 318.833,139.167 318.5,138.5C 320.083,136.492 321.083,134.159 321.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d8e3",
    d: "M 373.5,132.5 C 372.833,132.5 372.167,132.5 371.5,132.5C 370.515,136.634 370.182,140.968 370.5,145.5C 369.352,141.019 369.185,136.352 370,131.5C 371.756,130.015 372.923,130.348 373.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6477a0",
    d: "M 85.5,131.5 C 86.5,131.5 87.5,131.5 88.5,131.5C 88.5,136.5 88.5,141.5 88.5,146.5C 87.5,146.5 86.5,146.5 85.5,146.5C 85.5,141.5 85.5,136.5 85.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b608f",
    d: "M 105.5,132.5 C 106.5,132.5 107.5,132.5 108.5,132.5C 108.187,136.042 108.521,139.375 109.5,142.5C 109.791,143.649 110.624,144.316 112,144.5C 113.699,144.613 114.866,143.947 115.5,142.5C 116.166,139.311 116.833,135.977 117.5,132.5C 118.487,135.768 118.82,139.102 118.5,142.5C 118.5,142.833 118.5,143.167 118.5,143.5C 116.112,146.076 113.112,147.076 109.5,146.5C 108.206,145.71 107.039,144.71 106,143.5C 105.501,139.848 105.335,136.182 105.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a608f",
    d: "M 169.5,133.5 C 169.306,137.005 168.306,137.338 166.5,134.5C 164.833,134.5 163.167,134.5 161.5,134.5C 160.539,136.265 160.205,138.265 160.5,140.5C 160.5,141.833 160.5,143.167 160.5,144.5C 163.059,144.802 165.393,144.468 167.5,143.5C 167.5,142.5 167.5,141.5 167.5,140.5C 167.833,140.5 168.167,140.5 168.5,140.5C 171.132,142.699 170.799,144.699 167.5,146.5C 164.5,146.5 161.5,146.5 158.5,146.5C 158.5,141.833 158.5,137.167 158.5,132.5C 162.283,130.993 165.95,131.327 169.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#415a8b",
    d: "M 250.5,132.5 C 252.436,136.715 253.103,141.381 252.5,146.5C 250.564,142.285 249.897,137.619 250.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acb7cc",
    d: "M 269.5,146.5 C 269.827,141.786 269.493,137.12 268.5,132.5C 267.833,135.5 267.167,138.5 266.5,141.5C 265.893,141.376 265.56,141.043 265.5,140.5C 266.479,137.375 266.813,134.042 266.5,130.5C 267.833,130.5 269.167,130.5 270.5,130.5C 270.821,136.026 270.488,141.36 269.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e90b0",
    d: "M 321.5,131.5 C 322.5,131.5 323.5,131.5 324.5,131.5C 324.821,136.695 324.487,141.695 323.5,146.5C 323.666,141.821 323.499,137.155 323,132.5C 322.502,135.482 322.335,138.482 322.5,141.5C 321.209,141.737 320.209,141.404 319.5,140.5C 321.388,138.012 322.055,135.012 321.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbc2d5",
    d: "M 358.5,133.5 C 358.573,135.027 357.906,136.027 356.5,136.5C 356.427,134.973 357.094,133.973 358.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adb7cc",
    d: "M 34.5,132.5 C 35.209,131.596 36.209,131.263 37.5,131.5C 37.8205,136.695 37.4872,141.695 36.5,146.5C 37.1031,141.381 36.4364,136.715 34.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b2c8",
    d: "M 60.5,134.5 C 60.5569,135.609 60.8902,136.609 61.5,137.5C 59.4482,136.947 59.1148,135.947 60.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#435c8c",
    d: "M 129.5,134.5 C 128.834,138.353 128.167,142.353 127.5,146.5C 126.833,142.353 126.166,138.353 125.5,134.5C 124.737,133.732 123.737,133.232 122.5,133C 125.833,132.333 129.167,132.333 132.5,133C 131.263,133.232 130.263,133.732 129.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8ebf0",
    d: "M 161.5,134.5 C 163.167,134.5 164.833,134.5 166.5,134.5C 166.5,135.5 166.5,136.5 166.5,137.5C 164.833,137.5 163.167,137.5 161.5,137.5C 161.5,136.5 161.5,135.5 161.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f90b0",
    d: "M 169.5,133.5 C 170.124,133.917 170.457,134.584 170.5,135.5C 169.453,137.056 168.786,138.723 168.5,140.5C 168.167,140.5 167.833,140.5 167.5,140.5C 165.844,138.94 163.844,137.94 161.5,137.5C 163.167,137.5 164.833,137.5 166.5,137.5C 166.5,136.5 166.5,135.5 166.5,134.5C 168.306,137.338 169.306,137.005 169.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a6190",
    d: "M 191.5,134.5 C 193.063,135.945 194.396,137.611 195.5,139.5C 195.811,140.478 196.478,141.145 197.5,141.5C 198.484,138.572 198.817,135.572 198.5,132.5C 200.436,136.715 201.103,141.381 200.5,146.5C 199.041,146.567 197.708,146.234 196.5,145.5C 196.573,143.973 195.906,142.973 194.5,142.5C 193.488,141.128 192.488,139.795 191.5,138.5C 191.44,137.957 191.107,137.624 190.5,137.5C 189.516,140.428 189.183,143.428 189.5,146.5C 188.833,146.5 188.167,146.5 187.5,146.5C 187.173,141.786 187.507,137.12 188.5,132.5C 189.518,133.193 190.518,133.859 191.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98a5c0",
    d: "M 198.5,132.5 C 198.817,135.572 198.484,138.572 197.5,141.5C 196.478,141.145 195.811,140.478 195.5,139.5C 197.083,137.492 198.083,135.159 198.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb9cd",
    d: "M 234.5,132.5 C 233.5,132.5 232.5,132.5 231.5,132.5C 231.5,137.167 231.5,141.833 231.5,146.5C 230.513,141.695 230.179,136.695 230.5,131.5C 232.099,131.232 233.432,131.566 234.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1adc5",
    d: "M 250.5,132.5 C 249.897,137.619 250.564,142.285 252.5,146.5C 251.791,147.404 250.791,147.737 249.5,147.5C 249.179,142.305 249.513,137.305 250.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adb8cd",
    d: "M 363.5,134.5 C 365.104,135.287 365.771,136.62 365.5,138.5C 364.326,137.486 363.66,136.153 363.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f83a7",
    d: "M 391.5,134.5 C 392.323,137.977 392.823,141.644 393,145.5C 393.177,141.644 393.677,137.977 394.5,134.5C 394.5,138.5 394.5,142.5 394.5,146.5C 393.5,146.5 392.5,146.5 391.5,146.5C 391.5,142.5 391.5,138.5 391.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4dae5",
    d: "M 394.5,146.5 C 394.5,142.5 394.5,138.5 394.5,134.5C 395.833,134.5 397.167,134.5 398.5,134.5C 398.5,133.5 398.5,132.5 398.5,131.5C 394.833,131.5 391.167,131.5 387.5,131.5C 387.5,132.5 387.5,133.5 387.5,134.5C 386.566,133.432 386.232,132.099 386.5,130.5C 390.833,130.5 395.167,130.5 399.5,130.5C 399.5,132.167 399.5,133.833 399.5,135.5C 398.167,135.5 396.833,135.5 395.5,135.5C 395.815,139.371 395.482,143.038 394.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acb8cc",
    d: "M 43.5,132.5 C 42.5,132.5 41.5,132.5 40.5,132.5C 40.5,137.167 40.5,141.833 40.5,146.5C 39.5128,141.695 39.1795,136.695 39.5,131.5C 41.099,131.232 42.4324,131.566 43.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ca8c2",
    d: "M 118.5,142.5 C 118.82,139.102 118.487,135.768 117.5,132.5C 116.833,135.977 116.166,139.311 115.5,142.5C 115.5,138.833 115.5,135.167 115.5,131.5C 116.833,131.5 118.167,131.5 119.5,131.5C 119.815,135.371 119.482,139.038 118.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#566996",
    d: "M 146.5,132.5 C 144.473,132.338 142.473,132.505 140.5,133C 142.382,133.198 144.048,133.698 145.5,134.5C 140.167,133.833 137.833,136.167 138.5,141.5C 137.075,139.969 136.409,140.302 136.5,142.5C 135.532,140.393 135.198,138.059 135.5,135.5C 136.962,134.542 138.295,133.376 139.5,132C 142.039,131.204 144.372,131.371 146.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9daac3",
    d: "M 191.5,134.5 C 190.518,133.859 189.518,133.193 188.5,132.5C 187.507,137.12 187.173,141.786 187.5,146.5C 186.513,141.695 186.179,136.695 186.5,131.5C 189.285,130.916 190.952,131.916 191.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a608f",
    d: "M 234.5,132.5 C 235.759,133.979 236.759,135.646 237.5,137.5C 238.5,138.167 239.5,138.833 240.5,139.5C 240.179,141.048 239.179,141.715 237.5,141.5C 237.573,139.973 236.906,138.973 235.5,138.5C 235.44,137.957 235.107,137.624 234.5,137.5C 234.094,140.939 233.094,143.939 231.5,146.5C 231.5,141.833 231.5,137.167 231.5,132.5C 232.5,132.5 233.5,132.5 234.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb9ce",
    d: "M 250.5,132.5 C 251.209,131.596 252.209,131.263 253.5,131.5C 253.821,136.695 253.487,141.695 252.5,146.5C 253.103,141.381 252.436,136.715 250.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93a2bd",
    d: "M 34.5,132.5 C 33.8969,137.619 34.5636,142.285 36.5,146.5C 35.791,147.404 34.791,147.737 33.5,147.5C 33.1795,142.305 33.5128,137.305 34.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb6cb",
    d: "M 51.5,132.5 C 52.209,131.596 53.209,131.263 54.5,131.5C 54.8205,136.695 54.4872,141.695 53.5,146.5C 54.1031,141.381 53.4364,136.715 51.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b8cae",
    d: "M 176.5,134.5 C 176.5,135.5 176.5,136.5 176.5,137.5C 178.833,137.5 181.167,137.5 183.5,137.5C 183.5,138.5 183.5,139.5 183.5,140.5C 181.167,140.5 178.833,140.5 176.5,140.5C 176.5,141.5 176.5,142.5 176.5,143.5C 179.059,143.198 181.393,143.532 183.5,144.5C 180.833,144.5 178.167,144.5 175.5,144.5C 175.187,140.958 175.521,137.625 176.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f8eb0",
    d: "M 224.5,135.5 C 226.065,137.509 227.065,139.843 227.5,142.5C 225.166,140.824 224.166,138.491 224.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b6290",
    d: "M 244.5,146.5 C 244.5,143.5 244.5,140.5 244.5,137.5C 242.821,137.715 241.821,137.048 241.5,135.5C 242.906,135.027 243.573,134.027 243.5,132.5C 244.209,131.596 245.209,131.263 246.5,131.5C 247.108,136.944 246.442,141.944 244.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8cfdd",
    d: "M 281.5,135.5 C 281.279,138.279 281.612,140.946 282.5,143.5C 280.414,142.852 279.414,141.352 279.5,139C 279.387,137.301 280.053,136.134 281.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f6593",
    d: "M 328.5,133.5 C 329.167,133.5 329.833,133.5 330.5,133.5C 330.5,133.833 330.5,134.167 330.5,134.5C 330.5,135.5 330.5,136.5 330.5,137.5C 336.423,137.418 339.089,140.084 338.5,145.5C 335.57,146.299 332.57,146.632 329.5,146.5C 327.535,146.052 327.202,145.052 328.5,143.5C 330.972,144.766 333.306,144.766 335.5,143.5C 336.885,142.053 336.552,141.053 334.5,140.5C 329.31,140.344 327.31,138.011 328.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d6391",
    d: "M 348.5,146.5 C 347.5,146.5 346.5,146.5 345.5,146.5C 345.5,142.5 345.5,138.5 345.5,134.5C 344.737,133.732 343.737,133.232 342.5,133C 348.978,132.139 350.978,132.306 348.5,133.5C 348.5,137.833 348.5,142.167 348.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#445b8c",
    d: "M 43.5,132.5 C 45.4121,134.657 47.0787,136.991 48.5,139.5C 48.811,140.478 49.4777,141.145 50.5,141.5C 51.4841,138.572 51.8174,135.572 51.5,132.5C 53.4364,136.715 54.1031,141.381 53.5,146.5C 51.1274,145.797 49.1274,144.464 47.5,142.5C 47.573,140.973 46.9063,139.973 45.5,139.5C 45.5,138.833 45.1667,138.5 44.5,138.5C 44.44,137.957 44.1067,137.624 43.5,137.5C 43.0935,140.939 42.0935,143.939 40.5,146.5C 40.5,141.833 40.5,137.167 40.5,132.5C 41.5,132.5 42.5,132.5 43.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a6c1",
    d: "M 51.5,132.5 C 51.8174,135.572 51.4841,138.572 50.5,141.5C 49.4777,141.145 48.811,140.478 48.5,139.5C 50.0826,137.492 51.0826,135.159 51.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#687ca3",
    d: "M 75.5,134.5 C 76.3227,137.977 76.8227,141.644 77,145.5C 77.1773,141.644 77.6773,137.977 78.5,134.5C 78.5,138.5 78.5,142.5 78.5,146.5C 77.5,146.5 76.5,146.5 75.5,146.5C 75.5,142.5 75.5,138.5 75.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d719b",
    d: "M 161.5,134.5 C 161.5,135.5 161.5,136.5 161.5,137.5C 163.844,137.94 165.844,138.94 167.5,140.5C 165.5,140.5 163.5,140.5 161.5,140.5C 161.167,140.5 160.833,140.5 160.5,140.5C 160.205,138.265 160.539,136.265 161.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b2c8",
    d: "M 211.5,143.5 C 211.823,139.774 211.489,136.107 210.5,132.5C 209.833,136.313 209.166,139.979 208.5,143.5C 208.5,139.167 208.5,134.833 208.5,130.5C 209.833,130.5 211.167,130.5 212.5,130.5C 212.818,135.032 212.485,139.366 211.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#495f8f",
    d: "M 222.5,133.5 C 223.167,133.833 223.833,134.167 224.5,134.5C 224.5,134.833 224.5,135.167 224.5,135.5C 224.166,138.491 225.166,140.824 227.5,142.5C 227.833,143.167 228.167,143.833 228.5,144.5C 228.179,146.048 227.179,146.715 225.5,146.5C 225.737,145.209 225.404,144.209 224.5,143.5C 221.523,143.098 218.857,142.098 216.5,140.5C 216.232,138.901 216.566,137.568 217.5,136.5C 218.396,135.494 219.062,135.494 219.5,136.5C 219.5,137.167 219.5,137.833 219.5,138.5C 218.596,139.209 218.263,140.209 218.5,141.5C 220.167,141.5 221.833,141.5 223.5,141.5C 223.768,139.901 223.434,138.568 222.5,137.5C 222.5,137.167 222.5,136.833 222.5,136.5C 222.5,135.833 222.5,135.167 222.5,134.5C 222.5,134.167 222.5,133.833 222.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3d8e4",
    d: "M 219.5,136.5 C 220.5,136.5 221.5,136.5 222.5,136.5C 222.5,136.833 222.5,137.167 222.5,137.5C 222.5,138.5 222.5,139.5 222.5,140.5C 220.821,140.715 219.821,140.048 219.5,138.5C 219.5,137.833 219.5,137.167 219.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#415889",
    d: "M 302.5,132.5 C 305.87,133.031 307.537,135.031 307.5,138.5C 307.833,142.516 306.166,145.182 302.5,146.5C 300.097,146.552 297.764,146.219 295.5,145.5C 293.391,143.878 292.391,141.712 292.5,139C 292.307,136.992 292.974,135.492 294.5,134.5C 295.492,134.328 296.158,134.662 296.5,135.5C 295.371,137.628 295.204,139.961 296,142.5C 299.294,145.311 302.294,144.978 305,141.5C 306.087,138.386 305.254,136.053 302.5,134.5C 301.048,133.698 299.382,133.198 297.5,133C 299.134,132.506 300.801,132.34 302.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9ebf1",
    d: "M 302.5,134.5 C 305.254,136.053 306.087,138.386 305,141.5C 302.294,144.978 299.294,145.311 296,142.5C 295.204,139.961 295.371,137.628 296.5,135.5C 298.379,134.659 300.379,134.325 302.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb9ce",
    d: "M 45.5,139.5 C 46.9063,139.973 47.573,140.973 47.5,142.5C 46.0937,142.027 45.427,141.027 45.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#64789f",
    d: "M 95.5,134.5 C 96.3227,137.977 96.8227,141.644 97,145.5C 97.1773,141.644 97.6773,137.977 98.5,134.5C 98.5,138.5 98.5,142.5 98.5,146.5C 97.5,146.5 96.5,146.5 95.5,146.5C 95.5,142.5 95.5,138.5 95.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f90b1",
    d: "M 222.5,137.5 C 223.434,138.568 223.768,139.901 223.5,141.5C 221.833,141.5 220.167,141.5 218.5,141.5C 218.263,140.209 218.596,139.209 219.5,138.5C 219.821,140.048 220.821,140.715 222.5,140.5C 222.5,139.5 222.5,138.5 222.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6bfd1",
    d: "M 235.5,138.5 C 236.906,138.973 237.573,139.973 237.5,141.5C 236.094,141.027 235.427,140.027 235.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb9cd",
    d: "M 259.5,132.5 C 258.5,132.5 257.5,132.5 256.5,132.5C 256.5,137.167 256.5,141.833 256.5,146.5C 255.513,141.695 255.179,136.695 255.5,131.5C 257.099,131.232 258.432,131.566 259.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7386a9",
    d: "M 311.5,132.5 C 311.334,136.846 311.501,141.179 312,145.5C 312.183,142.635 312.683,139.969 313.5,137.5C 313.5,140.5 313.5,143.5 313.5,146.5C 312.5,146.5 311.5,146.5 310.5,146.5C 310.181,141.637 310.514,136.97 311.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e6391",
    d: "M 379.5,144.5 C 379.262,142.596 378.262,141.262 376.5,140.5C 376.068,139.29 375.401,138.29 374.5,137.5C 374.44,136.957 374.107,136.624 373.5,136.5C 372.679,139.447 372.179,142.447 372,145.5C 371.501,141.179 371.334,136.846 371.5,132.5C 372.167,132.5 372.833,132.5 373.5,132.5C 375.816,135.095 378.149,137.761 380.5,140.5C 381.167,137.5 381.833,134.5 382.5,131.5C 383.086,131.709 383.586,132.043 384,132.5C 384.499,137.155 384.666,141.821 384.5,146.5C 382.486,146.608 380.82,145.942 379.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9eabc3",
    d: "M 183.5,132.5 C 180.167,132.5 176.833,132.5 173.5,132.5C 173.5,137.167 173.5,141.833 173.5,146.5C 172.513,141.695 172.179,136.695 172.5,131.5C 176.371,131.185 180.038,131.518 183.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9b4ca",
    d: "M 260.5,138.5 C 259.523,141.287 259.19,144.287 259.5,147.5C 258.209,147.737 257.209,147.404 256.5,146.5C 258.094,143.939 259.094,140.939 259.5,137.5C 260.107,137.624 260.44,137.957 260.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b6290",
    d: "M 259.5,132.5 C 261.853,134.86 263.853,137.527 265.5,140.5C 265.56,141.043 265.893,141.376 266.5,141.5C 267.167,138.5 267.833,135.5 268.5,132.5C 269.493,137.12 269.827,141.786 269.5,146.5C 268.5,146.5 267.5,146.5 266.5,146.5C 266.573,144.973 265.906,143.973 264.5,143.5C 264.5,142.833 264.167,142.5 263.5,142.5C 263.573,140.973 262.906,139.973 261.5,139.5C 261.5,138.833 261.167,138.5 260.5,138.5C 260.44,137.957 260.107,137.624 259.5,137.5C 259.094,140.939 258.094,143.939 256.5,146.5C 256.5,141.833 256.5,137.167 256.5,132.5C 257.5,132.5 258.5,132.5 259.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb7ce",
    d: "M 261.5,139.5 C 262.906,139.973 263.573,140.973 263.5,142.5C 262.094,142.027 261.427,141.027 261.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8c0d2",
    d: "M 376.5,140.5 C 378.262,141.262 379.262,142.596 379.5,144.5C 377.738,143.738 376.738,142.404 376.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8cfdd",
    d: "M 135.5,135.5 C 135.198,138.059 135.532,140.393 136.5,142.5C 137.167,143.5 137.833,144.5 138.5,145.5C 136.983,145.489 135.816,144.823 135,143.5C 134.199,140.633 134.366,137.966 135.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8ebf1",
    d: "M 161.5,140.5 C 163.5,140.5 165.5,140.5 167.5,140.5C 167.5,141.5 167.5,142.5 167.5,143.5C 165.5,143.5 163.5,143.5 161.5,143.5C 161.5,142.5 161.5,141.5 161.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bcd0",
    d: "M 191.5,138.5 C 190.833,141.167 190.167,143.833 189.5,146.5C 189.183,143.428 189.516,140.428 190.5,137.5C 191.107,137.624 191.44,137.957 191.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6478a0",
    d: "M 216.5,140.5 C 218.857,142.098 221.523,143.098 224.5,143.5C 221.941,143.198 219.607,143.532 217.5,144.5C 216.632,146.625 215.632,146.791 214.5,145C 214.899,143.272 215.566,141.772 216.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#485f8f",
    d: "M 288.5,132.5 C 288.833,132.5 289.167,132.5 289.5,132.5C 289.5,133.833 288.833,134.5 287.5,134.5C 285.265,134.205 283.265,134.539 281.5,135.5C 280.053,136.134 279.387,137.301 279.5,139C 279.414,141.352 280.414,142.852 282.5,143.5C 285.159,143.917 287.492,144.917 289.5,146.5C 286.482,146.665 283.482,146.498 280.5,146C 279.117,144.729 278.117,143.229 277.5,141.5C 277.81,134.53 281.477,131.53 288.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba8c4",
    d: "M 334.5,140.5 C 336.552,141.053 336.885,142.053 335.5,143.5C 335.443,142.391 335.11,141.391 334.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d6391",
    d: "M 363.5,134.5 C 363.66,136.153 364.326,137.486 365.5,138.5C 365.5,139.167 365.5,139.833 365.5,140.5C 365.427,142.027 366.094,143.027 367.5,143.5C 367.715,145.179 367.048,146.179 365.5,146.5C 364.662,146.158 364.328,145.492 364.5,144.5C 364.5,144.167 364.5,143.833 364.5,143.5C 363.976,141.694 363.309,140.028 362.5,138.5C 361.26,136.015 360.26,136.015 359.5,138.5C 358.596,139.209 358.263,140.209 358.5,141.5C 359.873,141.343 361.207,141.51 362.5,142C 360.618,142.198 358.952,142.698 357.5,143.5C 356.662,143.842 356.328,144.508 356.5,145.5C 355.614,146.776 354.614,146.776 353.5,145.5C 355.105,142.686 356.105,139.686 356.5,136.5C 357.906,136.027 358.573,135.027 358.5,133.5C 360.756,130.695 362.423,131.028 363.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c7fa5",
    d: "M 359.5,138.5 C 360.5,141.167 361.5,141.167 362.5,138.5C 363.309,140.028 363.976,141.694 364.5,143.5C 362.167,143.5 359.833,143.5 357.5,143.5C 358.952,142.698 360.618,142.198 362.5,142C 361.207,141.51 359.873,141.343 358.5,141.5C 358.263,140.209 358.596,139.209 359.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadfe9",
    d: "M 362.5,138.5 C 361.5,141.167 360.5,141.167 359.5,138.5C 360.26,136.015 361.26,136.015 362.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#96a3bf",
    d: "M 365.5,140.5 C 366.906,140.973 367.573,141.973 367.5,143.5C 366.094,143.027 365.427,142.027 365.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bbd0",
    d: "M 63.5,140.5 C 65.1765,141.183 65.8432,142.517 65.5,144.5C 62.6146,144.194 59.9479,144.527 57.5,145.5C 56.9569,145.44 56.6236,145.107 56.5,144.5C 59.1667,143.833 61.8333,143.167 64.5,142.5C 64.1373,141.817 63.8039,141.15 63.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6c0d2",
    d: "M 150.5,135.5 C 151.634,137.966 151.801,140.633 151,143.5C 150.617,144.056 150.117,144.389 149.5,144.5C 150.299,141.57 150.632,138.57 150.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a6c1",
    d: "M 160.5,140.5 C 160.833,140.5 161.167,140.5 161.5,140.5C 161.5,141.5 161.5,142.5 161.5,143.5C 163.5,143.5 165.5,143.5 167.5,143.5C 165.393,144.468 163.059,144.802 160.5,144.5C 160.5,143.167 160.5,141.833 160.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6bed0",
    d: "M 194.5,142.5 C 195.906,142.973 196.573,143.973 196.5,145.5C 195.094,145.027 194.427,144.027 194.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd5e1",
    d: "M 217.5,144.5 C 219.607,143.532 221.941,143.198 224.5,143.5C 225.404,144.209 225.737,145.209 225.5,146.5C 227.179,146.715 228.179,146.048 228.5,144.5C 229.404,145.209 229.737,146.209 229.5,147.5C 227.833,147.5 226.167,147.5 224.5,147.5C 224.5,146.5 224.5,145.5 224.5,144.5C 222.167,144.5 219.833,144.5 217.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f8fb1",
    d: "M 241.5,135.5 C 241.821,137.048 242.821,137.715 244.5,137.5C 244.5,140.5 244.5,143.5 244.5,146.5C 243.834,143.972 243.168,141.306 242.5,138.5C 241.817,138.863 241.15,139.196 240.5,139.5C 239.5,138.833 238.5,138.167 237.5,137.5C 239.199,137.473 240.533,136.806 241.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ced4e2",
    d: "M 357.5,143.5 C 359.833,143.5 362.167,143.5 364.5,143.5C 364.5,143.833 364.5,144.167 364.5,144.5C 361.721,144.279 359.054,144.612 356.5,145.5C 356.328,144.508 356.662,143.842 357.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7284a8",
    d: "M 371.5,132.5 C 371.334,136.846 371.501,141.179 372,145.5C 372.179,142.447 372.679,139.447 373.5,136.5C 374.107,136.624 374.44,136.957 374.5,137.5C 373.523,140.287 373.19,143.287 373.5,146.5C 372.209,146.737 371.209,146.404 370.5,145.5C 370.182,140.968 370.515,136.634 371.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#435c8c",
    d: "M 34.5,132.5 C 36.4364,136.715 37.1031,141.381 36.5,146.5C 34.5636,142.285 33.8969,137.619 34.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7b2c9",
    d: "M 44.5,138.5 C 43.5233,141.287 43.19,144.287 43.5,147.5C 42.209,147.737 41.209,147.404 40.5,146.5C 42.0935,143.939 43.0935,140.939 43.5,137.5C 44.1067,137.624 44.44,137.957 44.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4b0c7",
    d: "M 125.5,134.5 C 126.166,138.353 126.833,142.353 127.5,146.5C 128.167,142.353 128.834,138.353 129.5,134.5C 129.5,138.833 129.5,143.167 129.5,147.5C 128.167,147.5 126.833,147.5 125.5,147.5C 125.5,143.167 125.5,138.833 125.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#405789",
    d: "M 146.5,132.5 C 147.833,133.5 149.167,134.5 150.5,135.5C 150.632,138.57 150.299,141.57 149.5,144.5C 148.167,145.167 146.833,145.833 145.5,146.5C 143.097,146.552 140.764,146.219 138.5,145.5C 137.833,144.5 137.167,143.5 136.5,142.5C 136.409,140.302 137.075,139.969 138.5,141.5C 141.54,145.473 144.706,145.473 148,141.5C 149.087,138.386 148.254,136.053 145.5,134.5C 144.048,133.698 142.382,133.198 140.5,133C 142.473,132.505 144.473,132.338 146.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b2c9",
    d: "M 235.5,138.5 C 234.523,141.287 234.19,144.287 234.5,147.5C 233.209,147.737 232.209,147.404 231.5,146.5C 233.094,143.939 234.094,140.939 234.5,137.5C 235.107,137.624 235.44,137.957 235.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6bed0",
    d: "M 264.5,143.5 C 265.906,143.973 266.573,144.973 266.5,146.5C 265.094,146.027 264.427,145.027 264.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9faac3",
    d: "M 282.5,143.5 C 285.167,143.5 287.833,143.5 290.5,143.5C 290.737,144.791 290.404,145.791 289.5,146.5C 287.492,144.917 285.159,143.917 282.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#405889",
    d: "M 311.5,132.5 C 312.167,132.5 312.833,132.5 313.5,132.5C 315.633,134.091 317.299,136.091 318.5,138.5C 318.833,139.167 319.167,139.833 319.5,140.5C 320.209,141.404 321.209,141.737 322.5,141.5C 322.335,138.482 322.502,135.482 323,132.5C 323.499,137.155 323.666,141.821 323.5,146.5C 321.938,146.267 320.605,145.6 319.5,144.5C 318.92,142.251 317.587,140.585 315.5,139.5C 315.5,138.167 314.833,137.5 313.5,137.5C 312.683,139.969 312.183,142.635 312,145.5C 311.501,141.179 311.334,136.846 311.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7cedc",
    d: "M 315.5,139.5 C 317.587,140.585 318.92,142.251 319.5,144.5C 317.413,143.415 316.08,141.749 315.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a6290",
    d: "M 183.5,132.5 C 181.167,133.167 178.833,133.833 176.5,134.5C 175.521,137.625 175.187,140.958 175.5,144.5C 178.167,144.5 180.833,144.5 183.5,144.5C 180.663,146.402 177.329,147.069 173.5,146.5C 173.5,141.833 173.5,137.167 173.5,132.5C 176.833,132.5 180.167,132.5 183.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0bacf",
    d: "M 118.5,143.5 C 118.489,145.017 117.823,146.184 116.5,147C 113.961,147.796 111.628,147.629 109.5,146.5C 113.112,147.076 116.112,146.076 118.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4afc6",
    d: "M 138.5,145.5 C 140.764,146.219 143.097,146.552 145.5,146.5C 144.726,147.147 143.726,147.48 142.5,147.5C 140.645,147.66 139.312,146.993 138.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0bbce",
    d: "M 158.5,132.5 C 158.5,137.167 158.5,141.833 158.5,146.5C 161.5,146.5 164.5,146.5 167.5,146.5C 164.375,147.479 161.042,147.813 157.5,147.5C 157.179,142.305 157.513,137.305 158.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5bfd2",
    d: "M 183.5,144.5 C 184.404,145.209 184.737,146.209 184.5,147.5C 180.629,147.815 176.962,147.482 173.5,146.5C 177.329,147.069 180.663,146.402 183.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3aec7",
    d: "M 295.5,145.5 C 297.764,146.219 300.097,146.552 302.5,146.5C 301.726,147.147 300.726,147.48 299.5,147.5C 297.645,147.66 296.312,146.993 295.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1c9d9",
    d: "M 338.5,145.5 C 338.389,146.117 338.056,146.617 337.5,147C 334.633,147.801 331.966,147.634 329.5,146.5C 332.57,146.632 335.57,146.299 338.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bac2d6",
    d: "M 367.5,143.5 C 368.434,144.568 368.768,145.901 368.5,147.5C 367.209,147.737 366.209,147.404 365.5,146.5C 367.048,146.179 367.715,145.179 367.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 438.5,204.5 C 293.167,204.5 147.833,204.5 2.5,204.5C 2.61071,203.883 2.94404,203.383 3.5,203C 148.167,202.333 292.833,202.333 437.5,203C 438.056,203.383 438.389,203.883 438.5,204.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbcLogo);
export default __webpack_public_path__ + "static/media/IBCLogo.f9c2748956226ab3286bddc5ff6d9232.svg";
export { ForwardRef as ReactComponent };